import React from 'react'
import { Navigate, Route, Routes } from 'react-router-dom'

import {
  SupervisionForm,
  SupervisionContext,
  APPS_COMBOS_IDS,
  ORDER_COMBOS_IDS,
  SupervisionCertificateForm,
  SupervisionDEForm,
} from '../../../features/supervision'
import { useCombos } from '../../../features/combos/hooks'
import { SupervisionDashboardPage } from './dashboard'

const SupervisionPageBare = () => {
  useCombos(APPS_COMBOS_IDS, ORDER_COMBOS_IDS)

  return (
    <Routes>
      <Route path="/" element={<SupervisionDashboardPage />} />
      <Route path="/:appId" element={<SupervisionForm />} />
      <Route path="/:appId/DE" element={<SupervisionDEForm />} />
      <Route path="/:appId/:certificateType" element={<SupervisionCertificateForm />} />

      <Route path="*" element={<Navigate to="/" />} />
    </Routes>
  )
}

export const SupervisionPage = (props) => {
  return (
    <SupervisionContext>
      <SupervisionPageBare {...props} />
    </SupervisionContext>
  )
}
